import DetalleLoteTarifaCliente from '../../../subComponents/pricing/tarifas/lotes_clientes/detalles'

const LoteDetallesCliente = (props) => {
    
        return <div className="fluid">
                    <DetalleLoteTarifaCliente />
            </div>
}

export default LoteDetallesCliente